<div class="modal-header">
  <h4 class="modal-title pull-left"> Security Notice</h4>
  <div aria-label="Close" (click)="onCancel()" class="close pull-right">
    <span aria-hidden="true">×</span></div>
</div>

<div class="modal-body">
  <p>You have Two-Factor Authentication Disabled <br> For additional security, please setup it at <a href="javascript:: void(0);" (click)="gotoProfile()">Account/Profile</a></p>
</div>
<div class="modal-footer">
  <div class="footer-wrapper">
    <div class="checkbox-item">
      <input class="checkbox-custom" type='checkbox' name="doNotAskMe" id="doNotAskMe"
        [(ngModel)]="doNotAskMe" (ngModelChange)="doNotAskMeValueChange($event)"/>
      <label class="checkbox-custom-label" for="doNotAskMe">
       Do not ask me again
      </label>
    </div>

    <div class="actions">
      <button class="btn btn-rbv" (click)="gotoProfile()">Setup</button>
    </div>
  </div>
</div>
